import { render } from "./PassModal.vue?vue&type=template&id=091b56ec&ts=true"
import script from "./PassModal.vue?vue&type=script&lang=ts"
export * from "./PassModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__